<template>
  <div class="account profile-pages">
    <div class="wrapper">
      <aside class="account__sidebar">
        <nav class="account__nav">
          <ul>
            <li v-for="page in pages"
                :ref="`page-${page.hash}`"
                :class="{'active' : page.hash === currentPage.hash}"
            >
              <a
                href="javascript:void(0)"
                @click="showPage(page)"
              >
                {{ getPageTitle(page) }}
              </a>
            </li>
          </ul>
          <div :style="navLineStyle" class="account__nav-line"></div>
        </nav>
      </aside>

      <div class="account__body">
        <transition name="slide">
          <template>
            <my-info-component v-if="showThisPage('info')" :lang="lang" :trans="trans"/>
            <my-bikes-component
              v-if="getShowPages && showThisPage('bikes')"
              :lang="lang"
              :trans="trans"
              :transfered="transferBike"/>
            <change-pwd-component v-if="showThisPage('change-password')" :trans="trans"/>
            <my-orders-component v-if="getShowPages && showThisPage('orders')" :trans="trans"/>
          </template>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'

export default {
  name: "ProfileComponent",
  props: ['lang', 'trans', 'token', 'register', 'transfer'],
  data() {
    return {
      pages: [],
      navLineStyle: {
        top: 0,
        height: '52px'
      },
      currentPage: {
        hash: 'info',
        title: 'My info'
      },
      transferBike: null
    }
  },
  created() {
    console.log(this.transfer)
    if ((this.token && this.token.length > 0) || this.hasOwnProperty('register')) {
      localStorage.setItem('access_token', this.token)
      window.history.replaceState({}, document.title, `/${this.lang}/profile`);
    }
    if (!localStorage.getItem('access_token')) {
      location.href = '/en/login'
      return
    }
    this.pages = [
      {
        hash: 'info',
        title: this.trans.text.myInfo.title
      },
      {
        hash: 'bikes',
        title: this.trans.text.myBikes.title
      },
      {
        hash: 'change-password',
        title: this.trans.text.changePassword.title
      },
      {
        hash: 'orders',
        title: this.trans.text.orders.title
      },
    ]
  },
  mounted() {
    this.$store.dispatch('user', {
      path: this.$path
    }).then(() => {
      console.log('[AUTH]Success')
    }).catch(() => {
      localStorage.removeItem('access_token')
      localStorage.removeItem('user')
      location.href = '/en/login'
    })
    if (this.hasOwnProperty('register')) {
      let eventName = this.register === true ? 'sign_up' : 'login';
      this.$gtag.event(eventName, {
        method: 'Apple',
      })
      setTimeout(() => {
        if (window.fbq) {
          if (this.register === true) {
            window.fbq('track', 'CompleteRegistration', {
              status: true,
              currency: "EUR",
              content_name: 'Apple'
            })
          } else {
            window.fbq('trackCustom', 'Login', {
              status: true,
              currency: "EUR",
              content_name: 'Apple'
            })
          }
        }
      })
    }
    this.AuthUserEmail();
    const params = new URLSearchParams(window.location.search)
    this.transferBike = params.get('bike')
    if (this.transferBike) {
      this.showPage({
        hash: 'bikes',
        title: this.trans.text.myBikes.title
      })
    } else if (window.location.hash) {
      let hash = window.location.hash.split('?')[0].substr(1);
      let current = this.pages.filter(page => {
        return page.hash === hash;
      });
      if (current.length === 1) {
        this.showPage(current[0]);
      }
    }
  },
  computed: {
    ...mapGetters(['getShowPages']),
  },
  methods: {
    ...mapActions(['AuthUserEmail']),
    async findPageByHash(hash) {
      for (let page of this.pages) {
        let pageFind = false;
        if (hash === page.hash) {
          this.currentPage = {
            hash: page.hash,
            title: page.title,
          };
          pageFind = true;
          break;
        }

        if (!pageFind) {
          this.currentPage = {
            hash: this.pages[0].hash,
            title: this.pages[0].title,
          };
        }
      }
    },
    getPageTitle(page) {
      if (
        localStorage.hasOwnProperty('user') &&
        !JSON.parse(localStorage.getItem('user')).is_changed_password &&
        page.hash === 'change-password'
      ) {
        return this.trans.text.changePassword.title2
      }
      return page.title
    },
    showThisPage(hash) {
      return this.currentPage.hash === hash;
    },
    showPage(page) {
      if (this.currentPage === page) {
        return;
      }
      this.currentPage = {...page};

      const activeNavItem = this.$refs[`page-${page.hash}`];

      const top = activeNavItem[0].offsetTop;
      const height = activeNavItem[0].getBoundingClientRect().height;

      this.navLineStyle = {
        top: `${top}px`,
        height: `${height}px`
      };
    },
  },
  watch: {
    hash: {
      handler: async function (val) {
        if (val) {
          await this.findPageByHash(val);
          this.showPage(this.currentPage, false);
        }
      },
      deep: true,
      immediate: true
    }
  }
}
</script>

<style scoped>
.slide-enter {
  opacity: 0;
  transform: translate3d(0, 400px, 0);
}

.slide-enter-active {
  transition: 1s cubic-bezier(0.68, 0, 0.265, 1);
}

.slide-leave-active {
  transition: 0.5s cubic-bezier(0.68, 0, 0.265, 1);
}

.slide-leave-to {
  opacity: 0;
  transform: translate3d(0, -400px, 0);
}

.account {
  transition: all 0.2s;
}
</style>
